import { DataField } from 'shared/providers/types';
import { CellFormatter } from 'shared/execution/types';

export class HubspotCellFormatter implements CellFormatter {
  getRowNumberFormats(fields: DataField[]): (string | null)[] {
    return fields.map((field) => {
      if (field.type === 'number') {
        return '0';
      }
      return null;
    });
  }

  getIdFormat() {
    return '0';
  }
}
